import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router';
import { AppNavigation } from './AppNavigation/AppNavigation';
import React from 'react';

export type PageLayoutProps = {
  children?: React.ReactNode;
  title: React.ReactNode;
};

const PageLayoutRoot = styled('div', { name: 'PageLayoutRoot' })(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(12),
}));

const PageLayoutContent = styled('div', { name: 'PageLayoutContent' })(() => ({}));

export const PageLayout = ({ children, title }: PageLayoutProps) => {
  return (
    <PageLayoutRoot>
      <AppNavigation title={title} />
      <PageLayoutContent>{children ?? <Outlet />}</PageLayoutContent>
    </PageLayoutRoot>
  );
};
